import TimeTabs from "./TimeTabs"

export default TimeTabs
